<script>
import moment from "moment";

export default {
  props: {
    ageParams: Object
  },
  data() {
    let monthBefore = undefined;
    let monthAfter = undefined;
    let ageBefore = undefined;
    let ageAfter = undefined;
    if (this.ageParams) {
      monthBefore = this.ageParams.monthBefore;
      monthAfter = this.ageParams.monthAfter;
      ageBefore = this.ageParams.ageBefore;
      ageAfter = this.ageParams.ageAfter;
    }
    return {
      ageList: [
        {
          value: "3"
        },
        {
          value: "4"
        },
        {
          value: "5"
        },
        {
          value: "6"
        },
        {
          value: "7"
        },
        {
          value: "8"
        },
        {
          value: "9"
        },
        {
          value: "10"
        },
        {
          value: "11"
        },
        {
          value: "12"
        },
        {
          value: "13"
        },
        {
          value: "14"
        },
        {
          value: "15"
        },
        {
          value: "16"
        },
        {
          value: "17"
        },
        {
          value: "18"
        },
        {
          value: "19"
        },
        {
          value: "20"
        }
      ],
      monthList: [
        {
          label: "零1个月",
          value: "1"
        },
        {
          label: "零2个月",
          value: "2"
        },
        {
          label: "零3个月",
          value: "3"
        },
        {
          label: "零4个月",
          value: "4"
        },
        {
          label: "零5个月",
          value: "5"
        },
        {
          label: "零6个月",
          value: "6"
        },
        {
          label: "零7个月",
          value: "7"
        },
        {
          label: "零8个月",
          value: "8"
        },
        {
          label: "零9个月",
          value: "9"
        },
        {
          label: "零10个月",
          value: "10"
        },
        {
          label: "零11个月",
          value: "11"
        },
        {
          label: "零12个月",
          value: "12"
        }
      ],
      monthBefore,
      monthAfter,
      ageBefore,
      ageAfter,
      ageStart: undefined,
      ageEnd: undefined
    };
  },
  methods: {
    querySearch(queryString, cb) {
      var results = queryString
        ? this.ageList.filter(this.createFilter(queryString))
        : this.ageList;
      cb(results);
    },
    createFilter(queryString) {
      const formatAge = "" + Math.floor(queryString);
      return ageList => {
        return ageList.value.indexOf(formatAge) > -1;
      };
    },
    onAgeChange(value) {
      const beforeMonth = this.ageBefore
        ? parseInt(this.ageBefore) * 12 + parseInt(this.monthBefore || 0)
        : undefined;
      const afterMonth = this.ageAfter
        ? parseInt(this.ageAfter) * 12 + parseInt(this.monthAfter || 0)
        : undefined;
      const before = moment()
        .endOf("months")
        .subtract(beforeMonth, "months");

      const end = moment()
        .endOf("months")
        .subtract(afterMonth, "months");
      if (beforeMonth) {
        this.ageStart = before;
      }
      if (afterMonth) {
        this.ageEnd = end;
      }
    }
  }
};
</script>

<template>
  <div class="ageRangeSelect">
    <el-autocomplete
      :fetch-suggestions="querySearch"
      placeholder="年龄"
      v-model="ageBefore"
      size="medium"
      :popper-append-to-body="false"
      class="ageSeletComponent"
      @change="onAgeChange"
      @input="onAgeChange"
      :debounce="500"
      :max="100"
      :min="3"
      :step="1"
      type="number"
    >
      <span slot="suffix">岁</span>
      <el-select v-model="monthBefore" @change="onAgeChange" slot="append" placeholder="月份">
        <el-option label="全部" value></el-option>
        <el-option
          v-for="monthItem in monthList"
          :key="'before' +  monthItem.label"
          :label="monthItem.label"
          :value="monthItem.value"
        ></el-option>
      </el-select>
    </el-autocomplete>至
    <el-autocomplete
      :fetch-suggestions="querySearch"
      @change="onAgeChange"
      @input="onAgeChange"
      placeholder="年龄"
      v-model="ageAfter"
      size="medium"
      :debounce="500"
      :popper-append-to-body="false"
      class="ageSeletComponent"
      :max="100"
      :min="3"
      :step="1"
      type="number"
    >
      <span slot="suffix">岁</span>
      <el-select v-model="monthAfter" @change="onAgeChange" slot="append" placeholder="月份">
        <el-option label="全部" value></el-option>
        <el-option
          v-for="monthItem in monthList"
          :key="'after' +  monthItem.label"
          :label="monthItem.label"
          :value="monthItem.value"
        ></el-option>
      </el-select>
    </el-autocomplete>
  </div>
</template>

<style lang="scss">
.ageRangeSelect {
  display: inline-block;

  .ageSeletComponent {
    width: 200px;
    margin-right: 10px;
    margin-left: 10px;

    .el-input-group__append {
      width: 60px;
    }

    .el-input__suffix {
      line-height: 36px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// yotta-vue-components/vision/ageRangeSelect.vue